
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mypage/invitation",
      function () {
        return require("private-next-pages/mypage/invitation/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mypage/invitation"])
      });
    }
  